import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementUI from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init({
    offset: 20,
    delay: 300, // values from 0 to 3000, with step 50ms
    duration: 800 // values from 0 to 3000, with step 50ms
});
let HomeInfo = {
    Tel: '',
    Fax: '',
    PostCode: '231−0023',
    Email: 'sales@nxt-info.com',
    Address: '横浜市中区山下町２１９番地',
    Building: 'カーサ丸徳２０2号',
    CompanyName: 'NXT株式会社',
    CompanyNo: 'NXT Co., Ltd.',
    Abbreviation: '（略称：NXT）',
    Representative: '伊藤　晃一',
    Katakana: 'イトウ　コウイチ',
    Capital: '600',
    Banks: '',
    CreateDate: '2025年10月01日',
    YearSell: '',
    HakenNo: '',
    Access: '',
    CTO: '',
    MapUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4634.285336596574!2d139.6440687229058!3d35.441354940997144!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185da5cf437f8f%3A0xe2b789349b9a4b48!2zTlhU5qCq5byP5Lya56S-!5e0!3m2!1szh-TW!2sjp!4v1762176558003!5m2!1szh-TW!2sjp'
}
const app = createApp(App)
    // load 
$.ajax({
    type: "GET",
    url: "/api/company.php",
    dataType: "json",
    success: (res) => {
        HomeInfo = res
        app.config.globalProperties.HomeInfo = res
        app.use(router).use(ElementUI).use(HomeInfo).use(AOS).mount('#app')
    },
    error: (res) => {
        app.config.globalProperties.HomeInfo = HomeInfo
        app.use(router).use(ElementUI).use(HomeInfo).use(AOS).mount('#app')
    },
});